// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2FccH","list":"styles_list__3Ccfr"};